<template>
  <div>
    <div class="content">
      <div class="content-list" v-for="(item, index) in data.list" :key="index">
        <a :href="item.video" target="_blank">
          <div class="content-img-wrap">
            <img class="content-img" :src="item.imgUrl" alt="Event video thumbnail">
          </div>
          <div class="content-wrapper">
            <p class="content-title">{{item.contentText}}</p>
          </div>
        </a>
      </div>
    </div>

    <a v-if="data.buttonLink" class="bottom-button" :href="data.buttonLink" target="_blank">
      {{data.buttonText}}
    </a>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex; flex-wrap: wrap;

  @include mobile {
    margin-top: -6px;
    justify-content: space-between;
  }
}

.content-list {
  position: relative;
  margin: 0 24px 27px 0;

  @include mobile {
    margin: 0;
  }

  &:nth-child(3n+3) {
    margin-right: 0;
  }

  @include mobile {
    width: calc(calc(100% - 15px) / 2);
    margin: 0 15px 26px 0;

    &:nth-child(3n+3) {
      margin-right: 15px;
    }
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}

.content-img {
  width: 384px; height: 210px;

  @include mobile {
    width: 100%; height: auto;
  }
}

.content-img-wrap {
  position: relative;
  &::before {
    content: "";
    position: absolute; top: 50%; left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 48px; height: 48px;
    background: url('~@/assets/transSave/resource/image/ef/69/efd0026a21de3da79eb68b8cb8a07969.png') center / cover no-repeat;

    @include mobile {
      width: 24px; height: 24px;
    }
  }
}

.content-wrapper {
  width: 384px; height: 112px;
  padding: 24px 36px;
  background: #FFFFFF;

  &:hover {
    .content-title {
      color: #376EFD;
    }
  }

  @include mobile {
    width: auto; height: auto;
    padding: 8px 0 0 0;
    background: transparent;
  }
}

.content-title {
  color: #000000;
  font-size: 18px; font-weight: 600;
  line-height: 32px;
  @include row(2);

  @include mobile {
    font-size: 13px; font-weight: 500;
    line-height: 21px;
  }
}

.bottom-button {
  display: flex; justify-content: center; align-items: center;
  box-sizing: border-box;
  width: 250px; height: 60px;
  margin: 13px auto 0;
  opacity: 0.9;
  border: 1px solid #000000;
  font-size: 18px; font-weight: 500;
  color: #000000;
  line-height: 60px;

  &:hover {
    background: #000000;
    color: #FFFFFF;
    opacity: 0.9;
  }

  @include mobile {
    width: fit-content;
    height: 36px;
    padding: 0 20px;
    font-size: 14px;
    line-height: 36px;
  }
}
</style>
